import { render, staticRenderFns } from "./HaventBookedPatientsWidget.vue?vue&type=template&id=074f1ace&"
import script from "./HaventBookedPatientsWidget.vue?vue&type=script&lang=js&"
export * from "./HaventBookedPatientsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports